import request from '@/service/request'
import qs from 'qs'
import { projectCode } from '@/lib/utils/dictionary'

// 微信分享接口
export function getWxShareApi(params, code) {
  const wxShareUrl = process.env.VUE_APP_WXSHARE
  // 地址
  const locationPath = window.location.href.split('#')[0]
  // 微信分享
  const url = `${wxShareUrl}/api/neo-system/thirdPart/auth/wx/config/noToken?url=` + encodeURIComponent(locationPath)

  return request({url, method: 'get'})
}


// 获取名额海报数据
export const getListGroupPosterApi = params => {
  let url = '/productpage/keti/listGroupByTypeV2'

  // 1v1课题
  if (projectCode.oneVipProjectCode.includes(params.standardCode)) {
    url = '/productpage/keti/listGroupByType'
  }

  return request({
    url,
    method: 'get',
    params
  })
}

// 获取名额海报时间
export const getListGroupPosterTimeApi = params => {
  return request({
    url: '/productpage/keti/getPosterCourseTime',
    method: 'get',
    params
  })
}

// 获取课题列表数据
export const getListApi = data => {
  // 课题列表分页查询接口
  return request({
    // url: '/productpage/keti/searchList',
    url: 'sdm/mtc/pubController/pageV2',
    method: 'post',
    data
  })
}

// 获取学科大类
export const getMajorListApi = () => {
  return request({
    url: 'sdm/mtc/pubController/getMajorList',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}

// 获取校区城市
export const getCityApi = (params) => {
  return request({
    url: '/productpage/courseCity',
    method: 'get',
    params
  })
}

// 课程海报接口
export const getPosterApi = (params) => {
  return request({
    url: '/productpage/keti/getPosterV3',
    method: 'get',
    params
  })
}

// 课题详情
export const getCourseDetailApi = (data) => {
  return request({
    url: '/sdm/mtc/pubController/get',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data
  })
}




// 获取课程学科附件
export function getCourseMajorAttachmentApi (data) {
  return request({
    url: '/yankeEnWebsite/getCourseMajorAttachment',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data)
  })
}

// 课程课表查询
export function getCourseScheduleApi (params, code) {

  return request({
    url: '/productpage/keti/listGroupByLessonV2',
    method: 'get',
    params
  })
}
